import { Copy, QrCode } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { brl } from "../lib/api";

export const PIX = { bank: "PicPay", key: "+5531975548913", keyType: "Telefone", fee: 30 };

export function PixInfo() {
  async function copy() {
    try {
      await navigator.clipboard.writeText(PIX.key);
      toast.success("Chave Pix copiada!");
    } catch {
      toast.error("Não foi possível copiar. Copie manualmente.");
    }
  }

  return (
    <div className="rounded-2xl border border-[#166534]/20 bg-[#F0FDF4] p-5" data-testid="pix-info">
      <div className="flex items-center gap-2 text-[#166534]">
        <QrCode className="w-5 h-5" />
        <p className="font-display font-extrabold">Pagamento por Pix</p>
      </div>
      <dl className="mt-3 grid grid-cols-2 gap-3 text-sm">
        <div><dt className="text-neutral-500 text-xs">Banco</dt><dd className="font-semibold" data-testid="pix-bank">{PIX.bank}</dd></div>
        <div><dt className="text-neutral-500 text-xs">Mensalidade</dt><dd className="font-semibold">{brl(PIX.fee)}</dd></div>
        <div className="col-span-2">
          <dt className="text-neutral-500 text-xs">Chave Pix ({PIX.keyType})</dt>
          <dd className="font-mono text-lg font-bold text-[#052E16]" data-testid="pix-key">{PIX.key}</dd>
        </div>
      </dl>
      <Button
        type="button"
        onClick={copy}
        className="mt-4 w-full rounded-full bg-[#166534] hover:bg-[#14532d] hover:text-white text-white"
        data-testid="copy-pix-key"
      >
        <Copy className="w-4 h-4 mr-2" /> Copiar chave Pix
      </Button>
    </div>
  );
}
